import { IEditSubscriptionPlans } from "../../utils/types";
import { apiManager } from "../api-manager";

export const editSubscriptionPlan = async (id: string, body: IEditSubscriptionPlans) => {
  const res = await apiManager.patch(`subscription-plan/admin/edit/${id}`, body);
  return res;
};
